import { CurrencyPipe, DatePipe, NgFor, NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { ClientServices } from './../../@theme/services/clients.service';
/* import { NbCardModule } from '@nebular/theme'; */
@Component({
    selector: 'gd-clientinfo',
    templateUrl: './clientinfo.component.html',
    styleUrls: ['./clientinfo.component.scss'],
    imports: [
        NgFor,
   /*      NbCardModule, */
        NgIf,
        CurrencyPipe,
        DatePipe,
    ]
})
export class ClientinfoComponent implements OnInit {
  public ClientListlisted: any
  public calculatedPrimaryAge: string
  public calculatedSecondaryAge: string
  @Input() clientId: number

  dataClientlist: any = [
    {
      FirstName: null,
      MiddleName: null,
      LastName: null,
      RepId: null,
      ClientTypeId: null,
      AccountName: null,
      TaxId: null,
      InsExp: null,
      DOB: null,
      Address1: null,
      Address2: null,
      City: null,
      State: null,
      ZipCode: null,
      EmailAddress: null,
      RepSignature: null,
      AssociatedPerson: null,
      AssociatedAccount: null,
      CopyOfDl: null,
      NewAccountForm: null,
      DateOfNewAccountForm: null,
      AnnualIncFrom: null,
      AnnualIncTo: null,
      NetWorthTo: null,
      NetWorthFrom: null,
      LiquidNWFrom: null,
      LiquidNWTo: null,
      ddlistInvestmentObjectiveID: null,
      InvObjectiveId: null,
      LiquidityNeedsList: null,
      TimeHorizonList: null,
      EquitiesExp: null,
      FixedIncExp: null,
      OptionsExp: null,
      MutFundsExp: null,
      Etfexp: null,
      RealEstateExp: null,
      InsuranceExp: null,
      Vaexp: null,
      FixedAnnExp: null,
      PrecMetExp: null,
      CommExp: null,
      OtherExp: null,
      OtherExpDesc: null,
      Comment: null,
      Uitexp: null,
      cbCopyToSecondary: null,
      CompanyName: null,
      SecondaryFirstName: null,
      SecondaryMiddleName: null,
      SecondaryLastName: null,
      SecondaryTaxID: null,
      SecondarycopyofDLView: null,
      SecondaryDOB: null,
      SecondaryAddress1: null,
      SecondaryAddress2: null,
      SecondaryCity: null,
      SecondaryState: null,
      SecondaryZipCode: null,
      AdvisorClient: null,
      AccountOpen: new UntypedFormControl(true),
      TaxIdmaskId: null,
      InvestmentTimeHorizonId: null,
      InvestmentTimeHorizonDescription: null,
      ProfileDescription: null,
      InvestDescription: null,
      LiquidDescription: null
    },
  ]

  constructor(
    private cliservice: ClientServices,
    private fb: UntypedFormBuilder,
  ) {}

  ngOnInit() {
    this.loadClientData(this.clientId)
  }

  loadClientData(cl: number) {
    const param = { ClientId: cl }
    this.cliservice.getClientClientList(param).subscribe((response: any[]) => {
      this.dataClientlist = response
      this.setPrimaryAge(response[0].dob)
      this.setSecondaryAge(this.dataClientlist[0].SecondaryDOB)
    })
  }

  setPrimaryAge(date: Date) {
    this.calculatedPrimaryAge = this.calculateAge(date) + 'yo'
  }

  setSecondaryAge(date: Date) {
    this.calculatedSecondaryAge = this.calculateAge(date) + 'yo'
  }

  calculateAge(date: Date): number {
    const millisecDifference = Date.now() - new Date(date).getTime()
    const millisecPerDay = 24 * 60 * 60 * 1000
    const millisecPerYear = 365.25 * millisecPerDay

    const yearDifference = Math.floor(millisecDifference / millisecPerYear)
    return yearDifference
  }
}
